import React from "react";
import { APPLY_URL, LOGO_URL } from "./constants";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-[#d4af37]/20 bg-[#060818]"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
                    <div>
                        <img
                            src={LOGO_URL}
                            alt="Deeper Networking"
                            className="h-14 w-auto mb-4"
                        />
                        <p className="font-display font-black text-3xl md:text-4xl tracking-tighter text-[#f6f1e1] max-w-md leading-tight">
                            Relationships,
                            <br />
                            not{" "}
                            <span className="font-serif-italic font-light text-[#f2c652]">
                                transactions.
                            </span>
                        </p>
                    </div>

                    <div className="flex flex-col md:items-end gap-4">
                        <a
                            href={APPLY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-apply-link"
                            className="font-display font-medium text-sm underline underline-offset-4 decoration-[#d4af37]/50 hover:decoration-[#f2c652] text-[#f2c652] hover:text-[#fcc001] transition-colors"
                        >
                            Apply Now →
                        </a>
                        <nav className="flex gap-6 text-sm font-body text-[#f6f1e1]/50">
                            <a
                                href="#who"
                                className="hover:text-[#f2c652] transition-colors"
                            >
                                Who It's For
                            </a>
                            <a
                                href="#layers"
                                className="hover:text-[#f2c652] transition-colors"
                            >
                                Layers
                            </a>
                            <a
                                href="#faq"
                                className="hover:text-[#f2c652] transition-colors"
                            >
                                FAQ
                            </a>
                        </nav>
                    </div>
                </div>

                <div className="mt-14 md:mt-20 pt-8 border-t border-[#d4af37]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs font-body text-[#f6f1e1]/40">
                    <span data-testid="footer-copyright">
                        © 2026 IntegrityGO. All rights reserved.
                    </span>
                    <span className="font-display uppercase tracking-[0.3em] text-[#d4af37]/70">
                        Deeper · Networking
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
